/*
 * TOMYRIS CUSTOM: UI-контроллер виджета подбора размера бра.
 * Ядро (чистая логика) - assets/tomyris-bra-size-widget.js (window.TomyrisBraFit).
 * Этот файл рендерит состояния §6 / тексты §7 поверх ядра. Только браузер.
 * Спека: docs/plans/bra-size-widget.md
 *
 * Использование:
 *   TomyrisBraFitUI.init(rootEl, {
 *     configKey: 'tomyris-push-up-bra',
 *     variantAvailable: function(variantKey){ return true|false; },  // опц.
 *     onSelect: function(variantKey){ ... }                          // опц.
 *   });
 * rootEl должен содержать разметку с data-bra-* (см. сниппет / превью).
 */
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  var Core = window.TomyrisBraFit;
  var S = Core ? Core.STATE : {};

  // ── Тексты §7. RU-дефолты здесь; витрина подменяет их из локали через
  // <script type="application/json" data-bra-i18n> (рендерит tomyris-bra-size-widget.liquid,
  // ключи general.tomyris.bra_*). Плейсхолдеры {{ x }} подставляет fmt().
  var T = {
    resultLabel: 'Ваш размер',
    selectBtn: 'Выбрать этот размер',
    selectSize: 'Выбрать {{ size }}',
    soldOutBtn: '{{ label }} - нет в наличии',
    soldOutCard: 'Ваш размер {{ size }}, но сейчас его нет в наличии. Напишите нам - сообщим о поступлении или подберём замену.',
    cupBoth: 'Подходит и на чашку {{ a }}, и на {{ b }}',
    cupOne: 'Чашка {{ a }}',
    meta: 'Международный {{ size }} · садится размер-в-размер',
    altCup: 'На границе размеров',
    altCupHi1: 'прошлые бра были велики в чашке', altCupHi2: 'чашка морщила или была свободна',
    altCupLo1: 'грудь полнее сверху', altCupLo2: 'прошлые бра были малы в чашке',
    altBand: 'На границе посадки',
    altBandUp1: 'пояс врезался или давил', altBandUp2: 'любите посадку посвободнее',
    altBandLo1: 'пояс задирался вверх', altBandLo2: 'любите посадку поплотнее',
    gapSuggest1: 'Точного размера под ваши мерки в этой модели нет: на поясе {{ band }} чашка {{ cup }} не выпускается.',
    gapSuggest2: 'Ближайший вариант - {{ size }}: чашка будет немного свободнее. Можно взять его или написать нам - подберём вместе.',
    gapWa1: 'Точного размера под ваши мерки в этой модели нет, а близкая замена сядет плохо - не хотим советовать наугад.',
    gapWa2: 'Напишите нам - подскажем, что подойдёт из других моделей, или поможем с выбором.',
    outGrid1: 'Ваши мерки вне размерной сетки этой модели.',
    outGrid2: 'Напишите нам - подберём вручную или подскажем подходящую модель.',
    invalid1: 'Похоже, в измерениях ошибка: обхват груди должен быть больше обхвата под грудью минимум на 10 см.',
    invalid2: 'Проверьте: не перепутаны ли поля местами и не измерена ли грудь в утягивающем белье.',
    invalidConfirm: 'Всё верно',
    invalidWa: 'Если всё верно - напишите нам в WhatsApp ниже, разберёмся вместе.',
    knownHint: 'Выберите чашку и размер — покажем ваш размер',
    tblUnderbust: 'Под грудью, см', tblBust: 'Грудь, см', tblDiff: 'Разница, см', tblCup: 'Чашка',
    legend1: 'Размер вида B/C подходит сразу на две чашки — и B, и C: бра тянется.',
    legend2: 'Чашка = разница обхватов, см:'
  };
  (function loadI18n() {
    if (typeof document.querySelector !== 'function') return; // тест-стаб без DOM-запросов
    var tag = document.querySelector('[data-bra-i18n]');
    if (!tag) return;
    try {
      var d = JSON.parse(tag.textContent || '{}');
      for (var k in d) if (d[k] && typeof d[k] === 'string') T[k] = d[k];
    } catch (e) { /* остаёмся на RU-дефолтах */ }
  })();
  function fmt(str, vars) {
    return String(str).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, k) { return vars && vars[k] != null ? vars[k] : ''; });
  }
  function nb(str) { return String(str).replace(/ /g, '&nbsp;'); } // заголовки таблицы без переносов

  var FILL = '#1a1a1a', TRACK = '#e6e6e6'; // заливка слайдера слева/справа

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

  // Полная таблица §8 + легенда чашек - строятся из конфига (один источник).
  // Диапазоны через дефис (как остальные size-таблицы сайта), легенда через «→» (как result-meta).
  function buildTable(config) {
    // Колонка «Грудь, см» — только если в конфиге есть данные (sku.bust); иначе таблица как была.
    var hasBust = config.bands.some(function (band) {
      return band.skus.some(function (sku) { return !!sku.bust; });
    });
    var rows = '';
    config.bands.forEach(function (band) {
      band.skus.forEach(function (sku) {
        rows += '<tr>' +
          '<td>' + band.rus + sku.label + '</td>' +
          '<td>' + band.int + sku.label + '</td>' +
          '<td>' + band.underbust[0] + '-' + band.underbust[1] + '</td>' +
          (hasBust ? '<td>' + (sku.bust ? sku.bust[0] + '-' + sku.bust[1] : '—') + '</td>' : '') +
          '<td>' + sku.diff[0] + '-' + sku.diff[1] + '</td>' +
          '<td>' + sku.label + '</td>' +
          '</tr>';
      });
    });
    return '<table><thead><tr>' +
      '<th>RUS</th><th>INT</th><th>' + nb(T.tblUnderbust) + '</th>' +
      (hasBust ? '<th>' + nb(T.tblBust) + '</th>' : '') +
      '<th>' + nb(T.tblDiff) + '</th><th>' + T.tblCup + '</th>' +
      '</tr></thead><tbody>' + rows + '</tbody></table>';
  }
  function buildLegend(config) {
    var parts = config.cupLegend.map(function (c) { return c.diff[0] + '-' + c.diff[1] + ' → ' + c.cup; });
    // Сначала поясняем слэш-метку (фидбэк Анны: «B/C» неочевидно), потом легенду чашек по разнице.
    return T.legend1 + ' ' + T.legend2 + ' ' + parts.join(' · ');
  }
  // Расшифровка слэш-метки чашки («85B/C» → «Подходит и на чашку B, и на C») — фидбэк Анны:
  // «2 чашки»/«B/C» неочевидно, поясняем словами и как ПЛЮС (один размер тянется на обе чашки,
  // не нужно выбирать). Буквы берём из RUS-метки (после цифр пояса).
  function cupPhrase(sizeRus) {
    var letters = String(sizeRus).replace(/^\d+/, '').split('/').filter(Boolean);
    if (letters.length === 2) return fmt(T.cupBoth, { a: letters[0], b: letters[1] });
    if (letters.length === 1) return fmt(T.cupOne, { a: letters[0] });
    return '';
  }

  // ── Сборка HTML результата по состоянию ────────────────────────────
  // XSS-инвариант: в innerHTML попадают ТОЛЬКО доверенные значения -
  // статичные строки T.*, константы конфига (sizeRus/variantKey/cup из CONFIGS)
  // и ЦЕЛЫЕ числа r.u/r.b (прошли parseInt → clamp). Пользовательских строк нет
  // (инпуты type=number дают только числа), поэтому экранирование не требуется.
  function renderResult(ctx, r) {
    var config = ctx.config;
    var box = ctx.resultEl;
    box.innerHTML = '';
    ctx.lastResult = r;

    function selectBtn(key, label, ghost) {
      var avail = ctx.variantAvailable(key);
      var cls = 'tomyris-bra-fit__select' + (ghost ? ' tomyris-bra-fit__select--ghost' : '');
      if (!avail) {
        return '<button type="button" class="' + cls + '" disabled>' + fmt(T.soldOutBtn, { label: label }) + '</button>';
      }
      return '<button type="button" class="' + cls + '" data-bra-select="' + key + '">' + label + '</button>';
    }

    // RESULT / RESULT_ALT_CUP / RESULT_ALT_BAND
    if (r.state === S.RESULT || r.state === S.RESULT_ALT_CUP || r.state === S.RESULT_ALT_BAND) {
      // Вариант распродан (§7.10)
      if (!ctx.variantAvailable(r.variantKey)) {
        box.appendChild(el('div', 'tomyris-bra-fit__card tomyris-bra-fit__card--info',
          '<p>' + fmt(T.soldOutCard, { size: r.sizeRus }) + '</p>'));
        return;
      }
      function altBlock(eyebrow, items, key, sizeRus) {
        var li = items.map(function (t) {
          return '<li><svg class="tomyris-bra-fit__ck" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 8.5l3.2 3.2L13 5"/></svg>' + t + '</li>';
        }).join('');
        return '<div class="tomyris-bra-fit__alt">' +
          '<div class="tomyris-bra-fit__alt-eyebrow">' + eyebrow + '</div>' +
          '<ul class="tomyris-bra-fit__checklist">' + li + '</ul>' +
          selectBtn(key, fmt(T.selectSize, { size: sizeRus }), true) + '</div>';
      }
      var html =
        '<div class="tomyris-bra-fit__card">' +
          '<span class="tomyris-bra-fit__resultlabel">' + T.resultLabel + '</span>' +
          '<span class="tomyris-bra-fit__size">' + r.sizeRus + '</span>' +
          '<span class="tomyris-bra-fit__cuphint">' + cupPhrase(r.sizeRus) + '</span>' +
          '<span class="tomyris-bra-fit__meta">' + fmt(T.meta, { size: r.sizeInt }) + '</span>' +
          selectBtn(r.variantKey, fmt(T.selectSize, { size: r.sizeRus }), false);

      if (r.state === S.RESULT_ALT_CUP) {
        var cupItems = (r.boundary === 16)
          ? [T.altCupHi1, T.altCupHi2]
          : [T.altCupLo1, T.altCupLo2];
        html += altBlock(T.altCup, cupItems, r.altVariantKey, r.altSizeRus);
      } else if (r.state === S.RESULT_ALT_BAND) {
        var bandItems = (r.bandEdge === 'upper')
          ? [T.altBandUp1, T.altBandUp2]
          : [T.altBandLo1, T.altBandLo2];
        html += altBlock(T.altBand, bandItems, r.altVariantKey, r.altSizeRus);
      }
      html += '</div>';
      box.innerHTML = html;
      return;
    }

    // GAP_SUGGEST (§7.7)
    if (r.state === S.GAP_SUGGEST) {
      box.appendChild(el('div', 'tomyris-bra-fit__card tomyris-bra-fit__card--gap',
        '<p>' + fmt(T.gapSuggest1, { band: r.bandRus, cup: r.cup }) + '</p>' +
        '<p>' + fmt(T.gapSuggest2, { size: r.nearestSizeRus }) + '</p>' +
        selectBtn(r.nearestVariantKey, fmt(T.selectSize, { size: r.nearestSizeRus }), false)));
      return;
    }

    // GAP_WHATSAPP (§7.8)
    if (r.state === S.GAP_WHATSAPP) {
      box.appendChild(el('div', 'tomyris-bra-fit__card tomyris-bra-fit__card--gap',
        '<p>' + T.gapWa1 + '</p><p>' + T.gapWa2 + '</p>'));
      return;
    }

    // OUT_OF_GRID (§7.9)
    if (r.state === S.OUT_OF_GRID) {
      box.appendChild(el('div', 'tomyris-bra-fit__card tomyris-bra-fit__card--gap',
        '<p>' + T.outGrid1 + '</p><p>' + T.outGrid2 + '</p>'));
      return;
    }

    // INVALID_INPUT (§7.11) - сначала подсказка; «всё верно» раскрывает WhatsApp
    if (r.state === S.INVALID_INPUT) {
      var card = el('div', 'tomyris-bra-fit__card tomyris-bra-fit__card--info',
        '<p>' + T.invalid1 + '</p><p>' + T.invalid2 + '</p>' +
        '<button type="button" class="tomyris-bra-fit__confirmlink" data-bra-confirm>' + T.invalidConfirm + '</button>' +
        '<div class="tomyris-bra-fit__confirmwrap" data-bra-confirmwrap hidden>' +
          '<p>' + T.invalidWa + '</p>' +
        '</div>');
      box.appendChild(card);
      return;
    }
  }


  // ── dataLayer-лог (§9), дебаунс 800мс ──────────────────────────────
  function logCalc(ctx, r) {
    if (!window.dataLayer) return;
    window.dataLayer.push({
      event: 'bra_fit_calculated', source: 'shopify_widget',
      product_key: ctx.config.productKey, underbust: r.u, bust: r.b, diff: r.diff,
      state: r.state, primary_size: r.sizeRus || r.nearestSizeRus || null,
      alt_size: r.altSizeRus || null, variant_key: r.variantKey || r.nearestVariantKey || null
    });
  }

  // ── Инициализация ──────────────────────────────────────────────────
  function init(root, opts) {
    opts = opts || {};
    if (!Core) { return; }
    var config = Core.getConfig(opts.configKey);
    if (!root || !config) return;
    if (root.__braFitBound) return;
    root.__braFitBound = true;

    var ctx = {
      config: config,
      resultEl: root.querySelector('[data-bra-result]'),
      inputs: {
        underbust: root.querySelector('[data-ms-range="underbust"]'),
        bust: root.querySelector('[data-ms-range="bust"]')
      },
      nums: {
        underbust: root.querySelector('[data-ms-num="underbust"]'),
        bust: root.querySelector('[data-ms-num="bust"]')
      },
      variantAvailable: opts.variantAvailable || function () { return true; },
      onSelect: opts.onSelect || function () {},
      lastResult: null,
      logTimer: null
    };

    function read(name) {
      var inp = ctx.inputs[name];
      var spec = config.input[name];
      var v = parseInt(inp.value, 10);
      if (isNaN(v)) v = spec.default;
      v = clamp(v, spec.uiMin, spec.uiMax);
      return v;
    }
    function syncDisplay(name, v) {
      // Живое число = редактируемый input. Не перетираем, пока в нём печатают (фокус) — иначе прыгает курсор.
      var d = ctx.nums[name];
      if (d && d !== document.activeElement) d.value = v;
    }
    function paintSlider(name) {
      var inp = ctx.inputs[name];
      if (!inp || inp.type !== 'range') return; // заливка только для слайдеров
      var min = +inp.min, max = +inp.max, v = +inp.value;
      var pct = (max > min) ? (v - min) / (max - min) * 100 : 0;
      inp.style.background = 'linear-gradient(to right,' + FILL + ' 0%,' + FILL + ' ' + pct + '%,' + TRACK + ' ' + pct + '%,' + TRACK + ' 100%)';
    }
    function recalc() {
      var u = read('underbust'), b = read('bust');
      syncDisplay('underbust', u); syncDisplay('bust', b); // живое значение рядом со слайдером
      paintSlider('underbust'); paintSlider('bust');       // заливка пройденной части
      var r = Core.calculate(config, u, b);
      renderResult(ctx, r);
      clearTimeout(ctx.logTimer);
      ctx.logTimer = setTimeout(function () { logCalc(ctx, r); }, 800);
    }

    // ── Путь «Знаю размер»: пояс·чашка кнопками → calculateFromSize → тот же renderResult ──
    var known = { band: null, cup: null };
    var bandsWrap = root.querySelector('[data-bra-bands]');
    var cupsWrap = root.querySelector('[data-bra-cups]');

    function buildChips() {
      if (bandsWrap) {
        // Размер (band) = российский/EU размер с ярлычка бра (≈ обхват под грудью в см). Межд. дубль убран
        // как шум для KZ-рынка — он остаётся в таблице и в карточке результата для справки.
        bandsWrap.innerHTML = config.bands.map(function (b) {
          return '<button type="button" class="tomyris-sc__cap-tag tomyris-bra-known__chip" data-bra-band="' + b.rus + '">' + b.rus + '</button>';
        }).join('');
      }
      if (cupsWrap) {
        cupsWrap.innerHTML = config.cupLegend.map(function (c) {
          return '<button type="button" class="tomyris-sc__cap-tag tomyris-bra-known__chip" data-bra-cup="' + c.cup + '">' + c.cup + '</button>';
        }).join('');
      }
    }
    function highlightCups() {
      if (!cupsWrap || known.band == null) return;
      var btns = cupsWrap.querySelectorAll('[data-bra-cup]');
      for (var i = 0; i < btns.length; i++) {
        var r = Core.calculateFromSize(config, known.band, btns[i].getAttribute('data-bra-cup'));
        btns[i].classList.toggle('is-dim', r.state !== Core.STATE.RESULT); // приглушаем чашки без точного размера на этом поясе
      }
    }
    function renderKnown() {
      if (known.band != null && known.cup) {
        var r = Core.calculateFromSize(config, known.band, known.cup);
        renderResult(ctx, r);
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'bra_fit_calculated', source: 'shopify_widget', entry: 'known',
            product_key: config.productKey, band: known.band, cup: known.cup, state: r.state,
            primary_size: r.sizeRus || r.nearestSizeRus || null, variant_key: r.variantKey || r.nearestVariantKey || null
          });
        }
      } else {
        ctx.resultEl.innerHTML = '<p class="tomyris-bra-fit__hint">' + T.knownHint + '</p>';
      }
    }
    function selectChip(group, val, btn) {
      var sibs = btn.parentNode.querySelectorAll('.is-active');
      for (var i = 0; i < sibs.length; i++) sibs[i].classList.remove('is-active');
      btn.classList.add('is-active');
      if (group === 'band') { known.band = parseInt(val, 10); highlightCups(); }
      else { known.cup = val; }
      renderKnown();
    }
    function paintMeasure() { paintSlider('underbust'); paintSlider('bust'); }
    // Тогл вверху: показывает панель режима, прячет другую. Тогл на месте → не прыгает.
    function switchMode(mode) {
      var btns = root.querySelectorAll('[data-bra-mode]');
      for (var i = 0; i < btns.length; i++) {
        var on = btns[i].getAttribute('data-bra-mode') === mode;
        btns[i].classList.toggle('is-active', on); btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var panels = root.querySelectorAll('[data-bra-modepanel]');
      for (var j = 0; j < panels.length; j++) panels[j].hidden = panels[j].getAttribute('data-bra-modepanel') !== mode;
      if (mode === 'measure') { paintMeasure(); recalc(); } // результат по меркам сразу
      else { renderKnown(); }                                // результат по пояс/чашка (или подсказка)
    }

    // Степперы +/- и прямой ввод
    root.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-bra-inc]');
      var dec = e.target.closest('[data-bra-dec]');
      var sel = e.target.closest('[data-bra-select]');
      var conf = e.target.closest('[data-bra-confirm]');
      var bandBtn = e.target.closest('[data-bra-band]');
      var cupBtn = e.target.closest('[data-bra-cup]');
      var modeBtn = e.target.closest('[data-bra-mode]');

      if (bandBtn) { selectChip('band', bandBtn.getAttribute('data-bra-band'), bandBtn); return; }
      if (cupBtn) { selectChip('cup', cupBtn.getAttribute('data-bra-cup'), cupBtn); return; }
      if (modeBtn) { switchMode(modeBtn.getAttribute('data-bra-mode')); return; }

      if (inc || dec) {
        var name = (inc || dec).getAttribute(inc ? 'data-bra-inc' : 'data-bra-dec');
        var spec = config.input[name];
        ctx.inputs[name].value = clamp(read(name) + (inc ? 1 : -1), spec.uiMin, spec.uiMax);
        recalc();
      } else if (sel) {
        ctx.onSelect(sel.getAttribute('data-bra-select'));
        if (window.dataLayer) {
          var r = ctx.lastResult || {};
          window.dataLayer.push({
            event: 'bra_fit_size_selected', source: 'shopify_widget',
            product_key: config.productKey, underbust: r.u, bust: r.b, diff: r.diff,
            state: r.state, selected_size: sel.getAttribute('data-bra-select')
          });
        }
      } else if (conf) {
        var wrap = root.querySelector('[data-bra-confirmwrap]');
        if (wrap) wrap.hidden = false;
        conf.hidden = true;
      }
    });
    ctx.inputs.underbust.addEventListener('input', recalc);
    ctx.inputs.bust.addEventListener('input', recalc);

    // Прямой ввод числа (точность на мобиле) ведёт слайдер; на blur нормализуем к валидному.
    // Шкала (границы) рендерится в сниппете tomyris-measure-slider — здесь не трогаем.
    ['underbust', 'bust'].forEach(function (name) {
      var numEl = ctx.nums[name];
      var slEl = ctx.inputs[name];
      var spec = config.input[name];
      if (!numEl) return;
      numEl.addEventListener('input', function () {
        var raw = parseInt(numEl.value, 10);
        if (isNaN(raw)) return; // не дёргаем расчёт во время очистки/набора
        slEl.value = clamp(raw, spec.uiMin, spec.uiMax);
        recalc();
      });
      numEl.addEventListener('change', function () {
        numEl.value = read(name); // нормализуем поле к clamped-значению слайдера
        recalc();
      });
    });

    // Полная таблица + легенда.
    // Штатный источник — метаобъект size_chart (данные портала): таблицу и note
    // рендерит Liquid общим сниппетом tomyris-size-chart-table, тем же, что у остальных
    // 73 сеток. Конфиг остаётся ФОЛБЭКОМ — на случай товара без метаобъекта.
    // Подбор это не затрагивает: калькулятор в любом случае считает по config.
    var tableTarget = root.querySelector('[data-bra-table-target]');
    var legendEl = root.querySelector('[data-bra-legend]');
    var hasServerTable = !!(tableTarget && tableTarget.querySelector('table'));
    if (tableTarget && !hasServerTable) tableTarget.innerHTML = buildTable(config);
    // note из метаобъекта уже стоит под таблицей — вторую легенду не добавляем
    if (legendEl && !hasServerTable) legendEl.textContent = buildLegend(config);

    // Старт: кнопки пояса/чашки + подсказка (до выбора). «По меркам» — по раскрытию disclosure.
    buildChips();
    switchMode('known'); // дефолт — «Знаю размер»
  }

  window.TomyrisBraFitUI = { init: init, renderResult: renderResult, TEXT: T };
})();
